export const removeFromFavoritesText = "$Wa";
export default {removeFromFavoritesText};